import { render, staticRenderFns } from "./data85.vue?vue&type=template&id=74ea03a5&scoped=true&"
import script from "./data85.vue?vue&type=script&lang=js&"
export * from "./data85.vue?vue&type=script&lang=js&"
import style1 from "./data85.vue?vue&type=style&index=1&id=74ea03a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea03a5",
  null
  
)

export default component.exports